import { brandsData } from '@/mocks/home';

export default function Brands() {
  return (
    <section className="w-full py-12 px-4 md:px-6 bg-background-100" aria-label="合作伙伴">
      <div className="max-w-5xl mx-auto">
        <p className="text-center text-sm text-foreground-500 mb-8">
          来自各行业领先企业的用户正在使用好联系
        </p>
        <div className="grid grid-cols-3 md:grid-cols-6 gap-6 items-center justify-items-center">
          {brandsData.map((brand) => (
            <div key={brand.name} className="w-24 h-10 flex items-center justify-center">
              <img
                src={brand.logo}
                alt={brand.name}
                className="max-w-full max-h-full object-contain opacity-50 hover:opacity-80 transition-opacity duration-200"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}